import {BaseObject} from './BaseObject';

export class TransportStats extends BaseObject {
    id: number;
    name = '';
    surname = '';
    email: string;
    phone: string;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/TransportStats.ts